import { AnnotationSequencer } from './ordering/annotation-sequencer';
export class OrderedAnnotationResultsProcessor {
    constructor(annotationSequencer) {
        this.annotationSequencer = annotationSequencer !== null && annotationSequencer !== void 0 ? annotationSequencer : new AnnotationSequencer();
    }
    process(message, applyItem, onOperationProcessed, onMessageProcessed) {
        const operationPromises = [];
        for (const op of message.ops) {
            const operationItemPromises = [];
            if (op === null || op === void 0 ? void 0 : op.items) {
                for (const item of op.items) {
                    const promise = this.annotationSequencer.sequence(item.body)
                        .then(() => {
                        applyItem(op, item);
                    });
                    operationItemPromises.push(promise);
                }
            }
            operationPromises.push(Promise.all(operationItemPromises)
                .then(() => {
                onOperationProcessed(op, message.cv);
            }));
        }
        void Promise.all(operationPromises)
            .then(() => onMessageProcessed(message));
    }
}
//# sourceMappingURL=ordered-annotation-results-processor.js.map